import { inject } from '@angular/core';
import { HttpInterceptorFn, HttpErrorResponse, HttpRequest } from '@angular/common/http';
import { AuthService } from './auth.service';
import { catchError, first, switchMap } from 'rxjs/operators';
import { throwError } from 'rxjs';

function isAuthEndpoint(req: HttpRequest<any>): boolean {
  const url = req.url.toLowerCase();
  const method = req.method.toUpperCase();
  const isLogin = method === 'POST' && url.includes('/api/auth/login');
  const isRefresh = method === 'POST' && url.includes('/api/auth/refresh');
  const isLogout = method === 'POST' && url.includes('/api/auth/logout');
  return isLogin || isRefresh || isLogout;
}

export const AuthInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);

  const authReq = req.clone({
    withCredentials: true
  });

  if (isAuthEndpoint(req)) {
    return next(req);
  }

  return next(authReq).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status !== 401 || isAuthEndpoint(req)) {
        return throwError(() => error);
      }

      // Try one shared refresh
      return authService.refreshToken().pipe(
        first(),
        switchMap(res => {
          if (res?.expiresIn) {
            return next(
              req.clone({
                withCredentials: true
              })
            );
          }
          return authService.logout().pipe(
            switchMap(() => throwError(() => error))
          );
        }),
        catchError((refreshError) => {
          return authService.logout().pipe(
            switchMap(() => throwError(() => refreshError))
          );
        })
      );
    })
  );
};
